import { createSlice } from '@reduxjs/toolkit';

export const RegistroExpressCheckinSlice = createSlice({
  name: 'registroExpressCheckin',
  initialState: {
    registroExpressCheckinList: [],
    registroExpressCheckin: {},
  },
  reducers: {
    setRegistroExpressCheckinListRedux: (state, { payload }) => {
      state.registroExpressCheckinList = payload;
    },
    storeRegistroExpressCheckinRedux: (state, { payload }) => {
      state.registroExpressCheckin = payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const { setRegistroExpressCheckinListRedux, storeRegistroExpressCheckinRedux } =
  RegistroExpressCheckinSlice.actions;
